export type LandingLeadIntent = 'book_demo' | 'learn_more';

export const LANDING_LEAD_INTENT_EVENT = 'landingLeadIntentChange';

export const scrollToLandingLeadForm = (intent: LandingLeadIntent = 'learn_more') => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<{ intent: LandingLeadIntent }>(LANDING_LEAD_INTENT_EVENT, {
      detail: { intent },
    })
  );

  document
    .getElementById('ready-to-grow-practice')
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });

  window.setTimeout(() => {
    document.getElementById('cta-full-name')?.focus();
  }, 150);
};
